import type React from 'react';

import { Avatar, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import iconEmailSender from 'src/assets/icons/default_icon.png';

import type { PreviewEmailSenderInfoProps } from '../../../../types';

export const PreviewEmailSenderInfo: React.FC<PreviewEmailSenderInfoProps> = ({ userName }) => {
	return (
		<div className="mb-10 flex items-center">
			<Avatar src={iconEmailSender} alt={userName} size="small" />
			<div className="flex flex-col pl-4">
				<Text as="p" fontWeight="bold" size="small">
					<Translate
						value="fe.pages.petition_update_composer.preview.sender_info.sender_via_change_org"
						replacements={{ userName }}
					/>
				</Text>
				<Text as="p" size="small">
					<Translate value="fe.pages.petition_update_composer.preview.sender_info.to_me" />
				</Text>
			</div>
		</div>
	);
};
